<template>
  <div class="main-collection critical-component-clear">
    <div class="main-collection__header">
      <collection-hero
        :description="liquid.description"
        :image="liquid.image"
        :title="liquid.title"
        :filter="modelFilters"
        :filter-manager="filterManager"
        :button-url="liquid.heroLink"
        :button-label="liquid.heroLinkLabel"
      />

      <filter-bar
        v-if="enableHighlights && highlights.length > 0"
        :highlights="highlights"
      />
    </div>
    <collection-grid
      v-if="!klevuFetched"
      :banner="banner"
      :current-result-count="currentResultCount"
      :filters="currentFilters"
      :product-list="productList"
      :product-click-event="productClickEvent"
      :search-more="searchMore"
      :total-results-count="totalResultsCount"
      :template="template"
      :grid-class="gridClass"
      :grid-size="gridSize"
      :labels="labels"
      :liquid="liquid"
      loading
      @update-search-sort="updateSort"
      @load-more-products="loadMoreProducts"
      @update-filters="updateFilters"
      @all-cards-loaded="handleAllCardsLoaded"
    />
    <collection-grid
      v-else
      :banner="banner"
      :current-result-count="currentResultCount"
      :filters="currentFilters"
      :product-list="productList"
      :product-click-event="productClickEvent"
      :search-more="searchMore"
      :total-results-count="totalResultsCount"
      :template="template"
      :grid-class="gridClass"
      :grid-size="gridSize"
      :labels="labels"
      :liquid="liquid"
      @update-search-sort="updateSort"
      @load-more-products="loadMoreProducts"
      @update-filters="updateFilters"
      @all-cards-loaded="handleAllCardsLoaded"
    />
  </div>
</template>

<script>

import CollectionGrid from '~async/collection-grid/collection-grid'
import CollectionHero from '~async/collection-hero/collection-hero'
import FilterBar from '~async/filter-bar/filter-bar'

import { mapActions, mapState } from 'vuex'

import { initKlevu, sanitizedCollectionObject } from '~/apis/klevu'
import {
  applyFilterWithManager,
  categoryMerchandising,
  FilterManager,
  KlevuDomEvents,
  KlevuFetch,
  KlevuSearchSorting,
  listFilters,
  sendMerchandisingViewEvent,
// eslint-disable-next-line import/no-unresolved
} from '@klevu/core'

/**
 * Vue: Main collection (main-collection)
 * -----------------------------------------------------------------------------
 * Main collection page component.
 * - Static section.
 *
 */
export default {
  name: 'MainCollection',
  components: {
    CollectionGrid,
    CollectionHero,
    FilterBar,
  },
  props: {
    liquid: {
      type: Object,
      default: () => ({
        sectionId: '',
        blockLength: 0,
        title: '',
        description: '',
        products: [],
        pageInfo: {},

      }),
    },
    template: {
      type: String,
      default: '',
    },
    gridClass: {
      type: String,
      default: '',
    },
    gridSize: {
      type: String,
      default: '',
    },
    highlights: {
      type: Array,
      default: () => [],
    },
    banner: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    klevu: {
      type: Object,
      default: () => ({}),
    },
    enableHighlights: {
      type: Boolean,
      default: false,
    },
    labels: {
      type: Object,
      default: () => ({
        new: '',
        sale: '',
        most_popular: '',
        best_seller: '',
        freeShipping: '',
      }),
    },
  },

  data: () => {
    const { currency } = window.cnvs.store

    return {
      currency,
      productList: [],
      initialResults: null,
      sort: KlevuSearchSorting.Relevance,
      sortOptions: KlevuSearchSorting || [],
      klevuFetched: false,
      filterManager: new FilterManager(),
      totalResultsCount: null,
      currentResultCount: null,
      searchMore: false,
      productClickEvent: null,
    }
  },

  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      currentFilters: (state) => state.search.filters,
    }),

    modelFilters() {
      if (!this.currentFilters) {
        return
      }

      const modelFilters = this.currentFilters.filter((option) => option.key === 'sawmill_model' || option.key === 'sawmill_model_new')
      return modelFilters[0]
    },
  },

  async mounted() {
this.productList = [...this.liquid.products]
    await initKlevu(this.klevu.url, this.klevu.key)

    if (this.template.toLowerCase() !== 'sawmills') {
      await this.deafultFetchProducts()
    }

    if (!this.productList || this.productList.length <= 0) {
      this.productList = [...this.liquid.products]
    }

    if (this.banner) {
      this.productList.splice(4, 0, this.banner)
    }

    this.setKlevuEventListeners()
    this.setSortOptions()
  },

  methods: {

    /**
     * Map Vuex actions.
     */
    ...mapActions({
      setFilters: 'search/setFilters',
      setState: 'components/setState',
    }),

   
    handleAllCardsLoaded() {
      this.setState({ handle: 'main-collection-cards-loaded', state: 'active' })
    },

    async deafultFetchProducts() {
 
        const searchResult = await KlevuFetch(
          categoryMerchandising(
            this.title,
            {
              id: 'search',
              limit: 40,
              sort: this.sort,
              priceFieldSuffix: this.currency,
            },
            listFilters({
              filterManager: this.filterManager,
            }),
            applyFilterWithManager(this.filterManager),
            sendMerchandisingViewEvent(this.title),
          ),
        )
           
        if (!searchResult) {
          this.klevuFetched = false
          return
        }
        const result = searchResult.queriesById('search')
        const productIds = this.liquid.products.map(product => product.sku);
        const collection =  result.records
        const { totalResultsFound, noOfResults } = result.meta
        const productListKlevu= this.updateCollectionObject(collection)
        this.productList =productIds.map(sku => productListKlevu.find(product => product.sku === sku)).filter(product => product !== undefined);
        this.totalResultsCount = totalResultsFound
        this.currentResultCount = totalResultsFound < noOfResults ? totalResultsFound : noOfResults
        this.klevuFetched = true
        this.initialResults = result
        this.searchMore = Boolean(result.next)
        this.productClickEvent = result.getCategoryMerchandisingClickSendEvent()
        this.setFilters(this.filterManager.filters)

      },
    async fetchProducts() {
        const searchResult = await KlevuFetch(
          categoryMerchandising(
            this.title,
            {
              id: 'search',
              limit: 40,
              sort: this.sort,
              priceFieldSuffix: this.currency,
            },
            listFilters({
              filterManager: this.filterManager,
            }),
            applyFilterWithManager(this.filterManager),
            sendMerchandisingViewEvent(this.title),
          ),
        )
        if (!searchResult) {
          this.klevuFetched = false
          return
        }
        const result = searchResult.queriesById('search')
        const collection =  result.records
        const { totalResultsFound, noOfResults } = result.meta
        this.productList =this.updateCollectionObject(collection)
        this.totalResultsCount = totalResultsFound
        this.currentResultCount = totalResultsFound < noOfResults ? totalResultsFound : noOfResults
        this.klevuFetched = true
        this.initialResults = result
        this.searchMore = Boolean(result.next)
        this.productClickEvent = result.getCategoryMerchandisingClickSendEvent()
        this.setFilters(this.filterManager.filters)
    },
    setKlevuEventListeners() {
      document.addEventListener(KlevuDomEvents.FilterSelectionUpdate, this.fetchProducts)
    },
    /**
     * Update collection object to match specific markets and languages
     * @param {Object} collection - collection object from Klevu
     */
    updateCollectionObject(collection) {
      const productList = sanitizedCollectionObject(collection)
      const { products } = this.liquid
      const { baseCurrency, currency, language } = window.cnvs.store

      if (baseCurrency === currency && language.includes('en')) {
        return productList
      }
      const updatedList = productList.map((product) => {
        const matchingProduct = products.find(
          (item) => item.selectedOrFirstAvailableVariant.id === Number(product.id),
        )
        const matchingPrices =
          product.compareAtPrice?.amount === matchingProduct?.compareAtPrice?.amount ||
          product.price.amount === matchingProduct?.price?.amount

        if (matchingProduct && !matchingPrices) {
          product.compareAtPrice.amount = matchingProduct.compareAtPrice.amount || 0
          product.price.amount = matchingProduct.price.amount
          product.title = language.includes('en') ? product.title : matchingProduct.title
        }
       
        return product
      })
      return updatedList
    },
    setSortOptions() {
      const selectedOptions = ['RELEVANCE', 'NAME_ASC', 'NAME_DESC', 'PRICE_ASC', 'PRICE_DESC']
      this.sortOptions = selectedOptions
    },
    
    updateSort(sort) {
      this.sort = sort
      if(sort === 'RELEVANCE'){
        this.deafultFetchProducts()
      }else{
        this.fetchProducts()
      }
    },

    async loadMoreProducts() {
      const additionalProducts = await this.initialResults.next({
        filterManager: this.filterManager,
      })

      const searchResult = additionalProducts.queriesById('search')
      const { noOfResults, offset } = searchResult.meta

      this.productList = [
        ...this.productList,
        ...sanitizedCollectionObject(searchResult.records),
      ]
      this.currentResultCount = noOfResults + offset
      this.initialResults = searchResult
      this.searchMore = Boolean(searchResult.next)
    },
    

    captureClickedProduct(product) {
      this.productClickEvent(product.id, this.liquid.title)
      window.location = product.url
    },

    updateFilters(key, value) {
      this.filterManager.toggleOption(key, value)
    },


  
  },

}
</script>

<style lang="scss">
@import '~async/utils/selection-tab/selection-tab';
@import '~async/quantity-selector/quantity-selector';
@import '~async/utils/notification-panel/notification-panel';
@import '~async/utils/checkbox-input/checkbox-input';
@import '~async/product-card/product-card';
@import '~async/product-form/product-form';
@import '~async/collection-grid/collection-grid';
@import '~async/product-card-sawmill/product-card-sawmill';
@import '~async/product-card/product-card';
@import '~async/product-rating/product-rating';
@import '~async/main-collection/main-collection-filters';
@import '@/components/pagination';
@import './main-collection-filters';
@import './main-collection';
</style>
